import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { addErrorToast } from '../../../components/errors/toast/ToastUtils';
import { createAccount as createAccountService, AccountModel } from '../../../services/user/UserService';
import { useIntl } from 'react-intl';

interface Values {
  isLoading: boolean;
  createAccount: (newUser: AccountModel) => Promise<boolean>;
}

const useCreateAccount = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const intl = useIntl();

  const createAccount = async (newUser: AccountModel): Promise<boolean> => {
    try {
      setIsLoading(true);
      const result = await createAccountService(newUser);
      if (result.data != null) {
        setIsLoading(false);
        return true;
      } else {
        setIsLoading(false);
        addErrorToast({ message: intl.formatMessage({ id: 'errors.generic' }) });
        return false;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return false;
    }
  };

  return { createAccount, isLoading };
};

export default useCreateAccount;
